export default __webpack_public_path__ + "static/media/SketchUp-Icon-01.3b6d0345.svg";